import './index.scss';

import { ChangeEvent, Component, ReactNode } from 'react';

import { UncontrolledField } from '..';
import { BraxUncontrolledField } from '../BraxUncontrolledField';

export type BraxUncontrolledTextAreaFieldProps = UncontrolledField<string> & {
    label?: ReactNode,
    placeholder?: string,
    hint?: ReactNode,
    required?: boolean,
    maxLength?: number,
    onChange?: (value: string, event: ChangeEvent<HTMLTextAreaElement>) => void
};

export class BraxUncontrolledTextAreaField extends Component<BraxUncontrolledTextAreaFieldProps> {

    static defaultProps = {
        disabled: false,
        status: null,
        maxLength: 1024
    };

    change(event: ChangeEvent<HTMLTextAreaElement>) {
        if (this.props.onChange)
            this.props.onChange(event.target.value, event);
    }

    render() {
        const { id, label, hint, status, required, value, onChange, ...props } = this.props;

        return (
            <BraxUncontrolledField id={id}>
                { ({ id }) => (
                    <div className={`brax-text-area ${status}`}>
                        <div>
                            <textarea
                                id={id}
                                value={value !== null && value !== undefined ? value : ''}
                                onChange={event => this.change(event)}
                                {...props}
                            />

                            { label ? (
                                <label htmlFor={id}>{ label } { required ? '*' : null }</label>
                            ) : null }
                        </div>

                        { hint ? (
                            <span className="hint">{ hint }</span>
                        ) : null }
                    </div>
                ) }
            </BraxUncontrolledField>
        );
    }

}
